import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sxProps?: SxProps
  [prop: string]: any
}
export const PhotoMessageIcon = ({ sxProps, ...prop }: Props) => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ width: '16px', color: 'gray', height: '16px', ...sxProps }}
    {...prop}
  >
    <path d="M12.67 3.33v9.34H3.33V3.33h9.34Zm0-1.33H3.33C2.6 2 2 2.6 2 3.33v9.34C2 13.4 2.6 14 3.33 14h9.34c.73 0 1.33-.6 1.33-1.33V3.33C14 2.6 13.4 2 12.67 2ZM9.43 7.9l-2 2.59L6 8.76l-2 2.57h8L9.43 7.91Z" />
  </SvgIcon>
)

PhotoMessageIcon.defaultProps = {
  sxProps: null,
}
